import { render, staticRenderFns } from "./MyRegistrationForm.vue?vue&type=template&id=cd6dee2c&scoped=true&"
import script from "./MyRegistrationForm.vue?vue&type=script&lang=js&"
export * from "./MyRegistrationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd6dee2c",
  null
  
)

export default component.exports